import { AppMain } from "@canonical/react-components";
import type { ComponentProps } from "react";

type ContentWrapperProps = Pick<ComponentProps<typeof AppMain>, "children">;

export const ContentWrapper = ({ children }: ContentWrapperProps) => {
  return <AppMain>{children}</AppMain>;
};
